import type { ListType } from './app';
import type {
  GroceryNeedLoveListQuery,
  CreateGroceryMutationVariables,
  CreateGroceryNeedLoveMutationVariables,
  CreateGroceryPendingCartMutationVariables,
  CreateSavedGroceryMutationVariables,
  CreateSavedGroceryFromInstacartCartMutationVariables,
  SearchGroceryAvailableStoresAndSendEmailQuery,
  GroceriesQuery,
  GroceryEventsQuery,
  GroceryNeedLovesQuery,
  SavedGroceryQuery,
  MarkGroceryAsDoNotChargeMutationVariables,
  MarkGroceryNeedLoveMutationVariables,
  GetGroceryEstimationQuery,
  UpdateGroceryMutationVariables,
  GrocerySearchItemFragmentFragment,
  GrocerySearchItemRowFragmentFragment,
  UnpaidGroceryOrdersQuery,
  GroceryQuery,
} from '@/gql/graphql';

export type PaginatedGroceryNeedLoveTypeResponse = Extract<GroceryNeedLovesQuery['groceryNeedLoves'], {}>;
export type GroceryNeedLove = Extract<GroceryNeedLoveListQuery['groceryNeedLoveList'], {}>[number] & {
  grocery?: Grocery | null;
  submittedBy?: string;
  resolvedBy?: string;
  assignedTo?: string;
  assignedOperatorName?: string;
  customerPhoneNumber?: string;
};
export type GroceryInput = CreateGroceryMutationVariables;
export type GroceryNeedLoveInput = CreateGroceryNeedLoveMutationVariables['data'];
export type GroceryPendingCartInput = CreateGroceryPendingCartMutationVariables;
export type SavedGrocery = Extract<SavedGroceryQuery['savedGrocery'], {}>;
export type SavedGroceryInput = CreateSavedGroceryMutationVariables['data'];
export type SavedGroceryFromInstacartCartInput = CreateSavedGroceryFromInstacartCartMutationVariables;
export type GroceryStore = Extract<SearchGroceryAvailableStoresAndSendEmailQuery['searchGroceryAvailableStoresAndSendEmail'], {}>[number];
export type PaginatedGroceryTypeResponse = Extract<GroceriesQuery['groceries'], {}>;
export type Grocery = Extract<PaginatedGroceryTypeResponse['rows'], {}>[number] & {
  orderIndex?: number;
  isNeedLoveFilled?: boolean;
  link?: string;
  esitmateTime?: string;
  initialEstimateTime?: string;
  shopperName?: string;
  assignedOperatorName?: string;
  customerPhoneNumber?: string;
  isInteractedWithShopperTxt?: string;
  isConfirmedAddressAndNotesTxt?: string;
  priorityLevelTxt?: string;
  statusNumber?: number;
};
export type GroceryStoreItem = GroceryQuery['grocery']['storeItems'][number];
export type GroceryItemType = GroceryStoreItem['groceryItem'];
export type GroceryEvents = Extract<GroceryEventsQuery['groceryEvents'], {}>;
export type MarkGroceryAsDoNotChargeInput = MarkGroceryAsDoNotChargeMutationVariables;
export type MarkGroceryNeedLoveInput = MarkGroceryNeedLoveMutationVariables;
export type GroceryCost = Extract<GetGroceryEstimationQuery['getGroceryEstimation'], {}>;
export type UpdateGroceryInput = UpdateGroceryMutationVariables;
export type PaginatedGrocerySearchItemTypeResponse = Extract<GrocerySearchItemFragmentFragment, {}>;
export type GrocerySearchItem = Extract<GrocerySearchItemRowFragmentFragment, {}>;
export type PaginatedUnpaidGroceryOrderResponse = Extract<UnpaidGroceryOrdersQuery['unpaidGroceryOrders'], {}>;
export type UnpaidGroceryOrder = Extract<PaginatedUnpaidGroceryOrderResponse['rows'], {}>[number];

export interface GroceryNeedLoveFieldType {
  label?: string;
  type: 'input' | 'select' | 'multiple-select' | 'text' | 'number' | 'multiple';
  groups?: {
    fields: GroceryNeedLoveFieldType[];
  }[];
  options?: ListType[];
  required?: boolean;
  full?: boolean;
  offset?: boolean;
}

export enum GroceryRegistrationSteps {
  ServiceCheck = 0,
  Estimate = 1,
  CustomerInformation = 2,
  SaveCartFromInstacart = 3,
  ChooseMembership = 4,
  BillingInformation = 5,
  Confirmation = 6,
}

export enum ScheduledGrocerySteps {
  StoreInfo = 0,
  ItemInfo = 1,
  ScheduleInfo = 2,
}

export enum GroceryOrderStatus {
  Found = 'found',
  Replaced = 'replaced',
  Refunded = 'to_refund'
}
